import React, { useEffect, useState, useCallback, useRef } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { baseAPI } from '../../services/baseAPI';

function ResetPassword() {
  const { id, npp } = useParams();
  const history = useHistory();
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);
  const logout = useUserStore((state) => state.logout);

  const [isLoading, setIsLoading] = useState(false);

  const [oldPassword, setOldPassword] = useState(null);
  const [validOld, setValidOld] = useState(false);
  const [reNewPass, setReNewPass] = useState(null);
  const [newData, setNewData] = useState({
    newpass: null,
  })


  // CONTROLLER
  const updatePassword = async (id) => {
    Swal.fire({
      title: 'Apakah anda yakin ingin memperbarui password anda?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: 'Update',
      denyButtonText: `Don't update`,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(newData));

        baseAPI
          .put(`/v1/resetpass/${id}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Password anda berhasil diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
            console.log(`berhasil update ${JSON.stringify(res)}`);
            history.push('/auth/profile')
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Gagal memperbarui password anda.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
          })
      } else if (result.isDenied) {
        Swal.fire('Data is not updated', '', 'info')
      }
    });
  };

  const validateOld = async () => {
    setIsLoading(true);
    const body = new FormData();
    body.append('oldpass', oldPassword);

    await baseAPI 
      .post(`/v1/resetpass/${user.id}`, body, {
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((res) => {
        if (res.data.success === 'true') {
          setValidOld(true);
        } else {
          Swal.fire({
            icon: 'error',
            title: `Password lama anda tidak benar. Silahkan masukan ulang atau klik Lupa Password.`,
            showConfirmButton: false,
            timer: 1500
          })
        }
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal memvalidasi password lama`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
      })
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout(null);
  };

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>Reset Password</li>
          </ol>
        </div>
      </div>
    </div>
  );

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div>
                <p style={{fontSize: 25}}><b>Reset Password</b></p>
                <p>Jangan lupa klik "Save" jika telah melakukan perubahan. Jika anda lupa password lama anda, silahkan klik lupa password kemudian silahkan klik Lupas Password pada halaman Log In.</p>
              </div>
              
              {validOld === false ?
              <>
                {/* Password lama */}
                <div className='col-md-12 mb-3'>
                  <label htmlFor='true' className='form-label'>
                    Password Lama
                  </label>
                  <input
                    type="password"
                    autoComplete='off'
                    placeholder='Masukan password lama'
                    className="form-control"
                    onChange={e => setOldPassword(e.target.value)}
                  />
                </div>

                {/* button validate old password */}
                <div className='col-md-12 mb-3'>
                  <button
                    disabled={oldPassword !== null ? false : true}
                    type="button"
                    className='btn btn-success col-md-12'
                    style={{backgroundColor: '#6A9C89'}}
                    onClick={() => validateOld()}
                  >
                    Validasi
                  </button>
                </div>

                {/* button lupa old password */}
                <div className='col-md-12'>
                  <button
                    type="button"
                    className='btn btn-danger col-md-12'
                    style={{backgroundColor: '#CD5C08'}}
                    href="#handleLogout" 
                    onClick={(e) => handleLogout(e)}
                  >
                    Lupa Password Lama
                  </button>
                </div>
              </>              
              : <></>}

              {validOld ? 
              <>
                {/* New Password */}
                <div className='col-md-6 mb-3'>
                  <label htmlFor='true' className='form-label'>
                    Password Baru
                  </label>
                  <input
                    type="password"
                    autoComplete='off'
                    placeholder='Masukan password baru anda'
                    className="form-control"
                    onChange={e => setNewData({...newData, newpass: e.target.value})}
                  />
                </div>

                {/* Retype New Password */}
                <div className='col-md-6 mb-3'>
                  <label htmlFor='true' className='form-label'>
                    Ulangi Password Baru
                  </label>
                  <input
                    type="password"
                    autoComplete='off'
                    placeholder='Masukan kembali password baru anda'
                    className="form-control"
                    onChange={(e) => setReNewPass(e.target.value)}
                  />
                </div>

                <div className='col-md-12'>
                  {newData.newpass === reNewPass ? "" : <p className='text-danger'>Konfirmasi password baru belum sesuai. Periksa kembali password baru dan ulangi password baru anda.</p>}
                  <button
                    disabled={newData.newpass === reNewPass && newData.newpass !== null && reNewPass !== null ? false : true}
                    type="button"
                    className='btn btn-danger col-md-12'
                    style={{backgroundColor: '#CD5C08'}}
                    onClick={() => updatePassword(user.id)}
                  >
                    Update Password
                  </button>
                </div>
              </>              
              : <></>}

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}

    </div>
  );

}

export default ResetPassword;